export const TYPES_SUCCESS = 'TYPES_SUCCESS'
export const EXT_SUCCESS = 'EXT_SUCCESS'